import React, { useEffect, useState } from 'react'
import axios from 'axios';
import API_URL from '../../../ApiUrl';
import Multiselect from 'multiselect-react-dropdown';
import { useForm } from 'react-hook-form';
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const FormRegisMember = ({ infoAlamat, nextStep, setRegistrasi }) => {
    const [consultant,  setConsultant]  = useState([]);
    const [provinsi,    setProvinsi]    = useState([]);
    const [sekolah,     setSekolah]     = useState([]);
    const [kodeSekolah, setKodeSekolah] = useState([]);

    const formSchema = Yup.object().shape({
        email:          Yup.string().required("Email wajib diisi").email("Email tidak valid"),
        code_konsultan: Yup.string().required("Pilih salah satu konsultan"),
        id_provinsi:    Yup.string().required("Pilih provinsi sekolah"),
        password:       Yup.string().required("Password wajib diisi"),
        cpassword:      Yup.string()
            .required("Konfirmasi Password wajib diisi")
            .oneOf([Yup.ref("password")], "Password tidak sesuai"),
    });

    const { register, handleSubmit, formState: { errors }, setError } = useForm({
        mode: "onTouched",
        resolver: yupResolver(formSchema),
    });

    const setPilihanSekolah = (e) => setKodeSekolah(e[0]?.kode_sekolah);

    const onSubmit = (data) => {
        const regis = {
            ...data,
            kode_sekolah: kodeSekolah,
            nama_lengkap: infoAlamat.nama_lengkap,
            no_wa:        infoAlamat.notelp,
            id_propinsi:  infoAlamat.provinsi,
            id_kabkota:   infoAlamat.kabupaten,
        };
        setRegistrasi(regis);
        axios.post(API_URL.superStudent2 + '/niec-merchandise/check-member', data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(res => {
            if (res.data.data === 'expired') {
                setError('email', { type: 'custom', message: res.data.message });
            } else {
                nextStep();
            }
        })
        .catch(err => console.log(err));
    };

    const handleSekolah = (e) => {
        axios.get(API_URL.superStudent2 + '/sekolah-indonesia/' + e.target.value)
            .then(res => setSekolah(res.data.data))
            .catch(err => console.log(err));
    };

    useEffect(() => {
        axios.get(API_URL.superStudent2 + '/master/consultant/list-active')
            .then(res => setConsultant(res.data.data))
            .catch(err => console.log(err));
        axios.get(API_URL.superStudent2 + '/master/provinces')
            .then(res => setProvinsi(res.data.data))
            .catch(err => console.log(err));
    }, []);

    return (
        <div className="co-card">
            <div className="co-card-header">
                <div className="co-card-icon">
                    <i className="bi bi-person-badge-fill" />
                </div>
                <div>
                    <h4 className="co-card-title">Registrasi Member</h4>
                    <p className="co-card-desc">Lengkapi data untuk mendaftar sebagai member NIEC</p>
                </div>
            </div>

            <form onSubmit={handleSubmit(onSubmit)} className="co-form">
                {/* ── Akun ── */}
                <div className="co-section-divider">
                    <span><i className="bi bi-lock-fill me-1" />Data Akun</span>
                </div>

                <div className="co-field">
                    <label className="co-label"><i className="bi bi-envelope-fill me-1" />Email</label>
                    <input
                        type="email"
                        {...register("email")}
                        className={`co-input ${errors.email ? 'is-invalid' : ''}`}
                        placeholder="contoh@email.com"
                    />
                    {errors.email && <span className="co-error">{errors.email.message}</span>}
                </div>

                <div className="co-form-row">
                    <div className="co-field">
                        <label className="co-label"><i className="bi bi-key-fill me-1" />Password</label>
                        <input
                            type="password"
                            {...register("password")}
                            className={`co-input ${errors.password ? 'is-invalid' : ''}`}
                            placeholder="Password"
                        />
                        {errors.password && <span className="co-error">{errors.password.message}</span>}
                    </div>
                    <div className="co-field">
                        <label className="co-label"><i className="bi bi-shield-lock-fill me-1" />Konfirmasi Password</label>
                        <input
                            type="password"
                            {...register("cpassword")}
                            className={`co-input ${errors.cpassword ? 'is-invalid' : ''}`}
                            placeholder="Ulangi password"
                        />
                        {errors.cpassword && <span className="co-error">{errors.cpassword.message}</span>}
                    </div>
                </div>

                {/* ── Konsultan & Sekolah ── */}
                <div className="co-section-divider">
                    <span><i className="bi bi-people-fill me-1" />Info Konsultan &amp; Sekolah</span>
                </div>

                <div className="co-field">
                    <label className="co-label"><i className="bi bi-person-workspace me-1" />Pilih Konsultan</label>
                    <select
                        {...register("code_konsultan")}
                        className={`co-select ${errors.code_konsultan ? 'is-invalid' : ''}`}
                    >
                        <option value="">— Pilih Konsultan —</option>
                        {consultant?.map((con) => (
                            <option key={con.id} value={con.code}>
                                {con.name} ({con.office.kota})
                            </option>
                        ))}
                    </select>
                    {errors.code_konsultan && <span className="co-error">{errors.code_konsultan.message}</span>}
                </div>

                <div className="co-field">
                    <label className="co-label"><i className="bi bi-map-fill me-1" />Provinsi Sekolah</label>
                    <select
                        {...register("id_provinsi")}
                        className={`co-select ${errors.id_provinsi ? 'is-invalid' : ''}`}
                        onChange={handleSekolah}
                    >
                        <option value="">— Pilih Provinsi Sekolah —</option>
                        {provinsi?.map((prov, i) => (
                            <option key={i} value={prov.id}>{prov.province_name}</option>
                        ))}
                    </select>
                    {errors.id_provinsi && <span className="co-error">{errors.id_provinsi.message}</span>}
                </div>

                <div className="co-field">
                    <label className="co-label"><i className="bi bi-mortarboard-fill me-1" />Nama Sekolah</label>
                    <Multiselect
                        className="co-multiselect"
                        onSelect={setPilihanSekolah}
                        onRemove={setPilihanSekolah}
                        options={sekolah}
                        selectionLimit={1}
                        emptyRecordMsg="Data tidak ditemukan"
                        displayValue="nama_sekolah"
                        placeholder="Cari nama sekolah..."
                    />
                </div>

                <div className="co-form-footer">
                    <button type="submit" className="co-btn-primary">
                        <span>Selesaikan Registrasi</span>
                        <i className="bi bi-arrow-right ms-2" />
                    </button>
                </div>
            </form>
        </div>
    );
};

export default FormRegisMember;